import { fireLinkTag } from './tagManager';

// eslint-disable-next-line import/prefer-default-export
export const tagAltImagesClicked = () => {
  fireLinkTag({
    event_name: 'alt_image_clicked',
    link_name: 'alt_image_clicked',
  });
};

export const tagLastAltImagesClicked = () => {
  fireLinkTag({
    event_name: 'alt_last_image_clicked',
    link_name: 'alt_last_image_clicked',
  });
};

/**
 * Event for see more/fewer sizes
 * @param {boolean} isZoomedIn
 */
export const tagImageZoom = (isZoomedIn) => {
  const eventName = isZoomedIn ? 'pinch to zoom = Zoom In' : 'pinch to zoom = Zoom out';

  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};

/**
 * Event for see more/fewer sizes
 * @param {number} index
 */
export const tagImageClicked = (index) => {
  const eventName = `pdp image ${index} full screen`;

  fireLinkTag({
    event_name: eventName,
    link_name: eventName,
  });
};
